import { ReactElement } from 'react'

import NavBarItem, { ItemProps } from './navBarItem'
type MenuItemsProps = {
  items: MenuItem[]
}
const NavbarMenuItems = (props: MenuItemsProps): ReactElement => {
  const className = 'nav navbar-nav'
  return (
    <ul {...{ className }}>
      <li className="nav-dorpdown-overlay"></li>
      {props.items.map((item, index) => (
        <NavBarItem {...item} key={index} />
      ))}
    </ul>
  )
}

export type MenuItem = ItemProps
export default NavbarMenuItems
